{
  "$schema": "./schema.json",
  "bids": {
    "companyLoanBid": {
      "amount": "Summa",
      "paybackTimeMonths": "Takaisinmaksuaika",
      "amortizationMethod": "Lyhennystapa",
      "lenderMonthlyInterest": {
        "yearly": "Sopimuksessa ilmoitettu vuosikorko",
        "monthly": "Sopimuksessa ilmoitettu kuukausikorko"
      },
      "lenderMonthlyAmount": "Kiinteä kuukausikulu sopimuksessa",
      "averageMonthlyPayment": {
        "title": "Kuukausimaksu",
        "helperTitle": "Keskimääräinen kuukausimaksu"
      },
      "firstMonthPayment": "Maksu (ensimmäinen kuukausi)",
      "averageMonthlyCost": "Korkomaksu",
      "firstMonthCost": "Korkomaksu (ensimmäinen kuukausi)",
      "averageMonthlyAmortisation": "Pääoman lyhennys",
      "firstMonthAmortisation": "Pääoman lyhennys",
      "comparableMonthlyInterestRate": "Todellinen kuukausikorko",
      "comparableYearlyInterestRate": "Todellinen vuosikorko",
      "firstMonthInterestRate": "Ensimmäisen kuun korko",
      "earlyRepaymentFee": "Ennenaikaisen takaisinmaksun kustannukset",
      "setupFee": "Järjestelypalkkio",
      "postalFee": "Postimaksu (kuukaudessa)",
      "directDebitFee": "Suoraveloitusmaksu (kuukaudessa)"
    },
    "factoringBid": {
      "purchaseLimit": "Laskun ostoraja",
      "purchasedAmountPercent": "Rahoitusosuus (%)",
      "paymentTermsDays": "päivää",
      "commissionPercent": "Komissio laskua kohden",
      "withRegress": "Takautumisoikeus",
      "withRegressYes": "Kyllä",
      "withRegressNo": "Ei",
      "regressNumDaysAfterDueDate": "Takautumispäivien lukumäärä",
      "limitFeePerYearPercent": "Limiittimaksu (vuodessa)",
      "handlingFeePerInvoice": "Käsittelymaksu per lasku",
      "monthlyFee": "Kuukausimaksu",
      "amount": "Summa",
      "averageMonthlyCost": "Kuukausikustannus",
      "firstMonthCost": "Komissio (ensimmäinen kuukausi)",
      "comparableMonthlyInterestRate": "Todellinen kuukausikorko",
      "comparableYearlyInterestRate": "Todellinen vuosikorko",
      "firstMonthInterestRate": "Ensimmäisen kuun korko",
      "earlyRepaymentFee": "Ennenaikaisen takaisinmaksun kustannukset",
      "setupFee": "Järjestelypalkkio",
      "postalFee": "Postimaksu (kuukaudessa)",
      "directDebitFee": "Suoraveloitusmaksu (kuukaudessa)"
    },
    "realEstateBid": {
      "amount": "Summa",
      "paybackTimeMonths": "Laina-aika",
      "amortizationMethod": "Lyhennystapa",
      "lenderMonthlyInterest": {
        "yearly": "Sopimuksessa ilmoitettu vuosikorko",
        "monthly": "Sopimuksessa ilmoitettu kuukausikorko"
      },
      "lenderMonthlyAmount": "Kiinteä kuukausikulu sopimuksessa",
      "amortizationDuringTerm": "Lyhennys laina-aikana",
      "amortizationInPercent": "Lyhennys prosentteina",
      "averageMonthlyPayment": {
        "title": "Kuukausimaksu",
        "helperTitle": "Keskimääräinen kuukausimaksu"
      },
      "firstMonthPayment": "Maksu (ensimmäinen kuukausi)",
      "averageMonthlyCost": "Korkomaksu",
      "firstMonthCost": "Korkomaksu",
      "averageMonthlyAmortisation": "Pääoman lyhennys",
      "firstMonthAmortisation": "Pääoman lyhennys",
      "comparableMonthlyInterestRate": "Todellinen kuukausikorko",
      "comparableYearlyInterestRate": "Todellinen vuosikorko",
      "firstMonthInterestRate": "Ensimmäisen kuun korko",
      "earlyRepaymentFee": "Ennenaikaisen takaisinmaksun kustannukset",
      "setupFee": "Järjestelypalkkio",
      "postalFee": "Postimaksu (kuukaudessa)",
      "directDebitFee": "Suoraveloitusmaksu (kuukaudessa)"
    },
    "leasingBid": {
      "amount": "Summa",
      "paybackTimeMonths": "Takaisinmaksuaika",
      "downPayment": "Ennakkomaksu",
      "monthlyPayment": {
        "title": "Kuukausimaksu",
        "helperTitle": "Keskimääräinen kuukausimaksu"
      },
      "firstMonthPayment": "Maksu (ensimmäinen kuukausi)",
      "terminalValue": {
        "title": "Jäännösarvo",
        "description": "Jäännösarvo koskee vain leasingrahoitussopimuksia (eli ei vuokraa). Jäännösarvo näyttää kohteen arvioitua arvoa leasing-ajan lopussa. Kun sopimus päättyy, voit ostaa leasing-kohteen leasingyhtiöltä maksamalla jäännösarvon."
      },
      "contractType": {
        "label": "Sopimuksen tyyppi",
        "LEASING": {
          "title": "Leasing",
          "description": "Leasing sopii yrityksille, jotka haluavat investoida uusiin tai käytettyihin työkaluihin, koneisiin tai laitteisiin ilman, että heidän tarvitsee ostaa niitä tai lainata rahaa niitä varten. Leasingsopimuksen päätyttyä voit joko jatkaa sopimusta, ostaa kohteen jäännösarvolla tai palauttaa kohteen rahoittajalle."
        },
        "RENT": {
          "title": "Vuokra",
          "description": "Joskus on sopivampaa vuokrata kohde. Erityisesti jos haluat vaihtaa laitteita kesken leasing-ajan. Leasing-ajan lopussa voit pidentää vuokrasopimusta tai palauttaa vuokratun kohteen leasing-yhtiölle"
        }
      },
      "insuranceMonthlyCost": "Vakuutusmaksu (kuukaudessa)",
      "averageMonthlyCost": "Korkomaksu",
      "firstMonthCost": "Korkomaksu",
      "averageMonthlyAmortisation": "Pääoman lyhennys",
      "firstMonthAmortisation": "Pääoman lyhennys",
      "comparableMonthlyInterestRate": "Todellinen kuukausikorko",
      "comparableYearlyInterestRate": "Todellinen vuosikorko",
      "firstMonthInterestRate": "Ensimmäisen kuun korko",
      "earlyRepaymentFee": "Ennenaikaisen takaisinmaksun kustannukset",
      "setupFee": "Järjestelypalkkio",
      "postalFee": "Postimaksu (ei sisälly kuukausimaksuun)",
      "directDebitFee": "Suoraveloitusmaksu (kuukaudessa)"
    },
    "revolvingCreditBid": {
      "amount": "Summa",
      "lenderMonthlyInterest": {
        "yearly": "Korko (per vuosi)",
        "monthly": "Korko (per kuukausi)"
      },
      "monthlyAmortisation": "Lyhennys (kuukaudessa)",
      "withdrawalFee": {
        "title": "Nostopalkkio",
        "description": "Nostopalkkio veloitetaan joka kerta kun haluat nostaa lisävaroja sinulle myönnetystä limiitistä"
      },
      "limitFeePerYear": "Limiittimaksu (vuodessa)",
      "averageMonthlyPayment": "Kuukausittainen maksu (50% käyttöaste)",
      "firstMonthPayment": "Kuukausittainen maksu (100% käyttöaste)",
      "averageMonthlyCost": "Korkomaksu",
      "firstMonthCost": "Korkomaksu",
      "averageMonthlyAmortisation": "Pääoman lyhennys",
      "firstMonthAmortisation": "Pääoman lyhennys",
      "comparableMonthlyInterestRate": "Todellinen kuukausikorko",
      "comparableYearlyInterestRate": "Todellinen vuosikorko",
      "firstMonthInterestRate": "Ensimmäisen kuun korko",
      "earlyRepaymentFee": "Ennenaikaisen takaisinmaksun kustannukset",
      "setupFee": "Järjestelypalkkio",
      "postalFee": "Postimaksu (kuukaudessa)",
      "directDebitFee": "Suoraveloitusmaksu (kuukaudessa)"
    },
    "purchaseFinancingBid": {
      "amount": "Luottoraja",
      "lenderMonthlyInterest": {
        "title": "Korko per kuukausi",
        "helperTitle": "Korko lasketaan kuukausittain ja maksetaan kokonaisuudessaan eräpäivänä.",
        "summaryTitle": "Kuukausikorko",
        "summaryYearly": "Vuosikorko",
        "summaryTooltip": "Sopimuksessa"
      },
      "limitFeePerYear": "Limiittimaksu (vuodessa)",
      "paybackTimeDays": "Takaisinmaksuaika (päivää)",
      "averageMonthlyPayment": {
        "title": "Kuukausimaksu",
        "helperTitle": "Keskimääräinen kuukausimaksu"
      },
      "firstMonthPayment": "Maksu (ensimmäinen kuukausi)",
      "averageMonthlyCost": "Korkomaksu",
      "firstMonthCost": "Korkomaksu",
      "averageMonthlyAmortisation": "Pääoman lyhennys",
      "firstMonthAmortisation": "Pääoman lyhennys",
      "comparableMonthlyInterestRate": "Todellinen kuukausikorko",
      "comparableYearlyInterestRate": "Todellinen vuosikorko",
      "firstMonthInterestRate": "Ensimmäisen kuun korko",
      "setupFee": "Järjestelypalkkio",
      "postalFee": "Postimaksu (kuukaudessa)",
      "directDebitFee": "Suoraveloitusmaksu (kuukaudessa)"
    },
    "calculations": {
      "title": "Avainlaskelmat tarjoukseesi",
      "monthly": "Kuukausittain",
      "firstMonth": "Ensimmäinen kuukausi",
      "yearly": "Vuosittain"
    },
    "common": {
      "repayableWithoutFee": "Ei kustannuksia",
      "months": "kk",
      "month": "kk",
      "days": "päivää",
      "lender": "Lainanantaja"
    }
  }
}
